import React from 'react'
import { Form } from 'reactstrap'

export const SearchBar = ({ setSearchData }) => {

    return (
        <Form
            // className="form-inline mt-3 mb-1"
            className=''
            onSubmit={(e) => {
                e.preventDefault();
                setSearchData(e.target.inputSearchData.value);
            }}
        >
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-8 col-xxl-8 mb-2 pe-2 ps-2">
                    <input type="search" id="form1" className="form-control rounded-3 text-primary" placeholder="Buscar" aria-label="Search" name='inputSearchData' />
                </div>
                <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-4 col-xxl-4 ps-2 pe-2'>
                    <button type="submit" className="btn btn-dark py-2 rounded-3 w-100">
                        <span className="mdi mdi-magnify me-2"></span>Buscar
                    </button>
                </div>
            </div>
        </Form>
    )

}
